import { CommonSetting } from './Common/CommonSettings';
import { InvoiceSetting } from './InvoiceSetting';

export interface ApplicationConfiguration {
  CustomSettings: any;
  ProductSettings: any[];
  InvoiceSettings: InvoiceSetting[];
  Settings: CommonSetting[];
}

export class ApplicationConfiguration implements ApplicationConfiguration {
  CustomSettings: any;
  ProductSettings: any[];
  InvoiceSettings: InvoiceSetting[];
  Settings: CommonSetting[];
}
